import 'jquery-ui';
import flatpickr from "flatpickr";
import confirmDatePlugIn from "flatpickr/dist/plugins/confirmDate/confirmDate";
import { BlockPageHelper } from '../Helpers/helpers';
import { post } from "jquery";
import { Toast } from "bootstrap";
const Genesis = require("../Genesis.js");
let AutoComplete = require("./MaterialAutoComplete.js");
import Swal from "sweetalert2";

export class ISiteMobileWorkOrderEditMaterialPage {

    constructor() {
        $(() => {
            this.LoadDateFields();
        });
    }

    public Init() {
        AutoComplete();
        $("#saveMaterial").click((e: any) => {
            this.SubmitWOMaterialForm();
        });
    }

    public LoadDateFields() {
        const dateConfig: any = {
            dateFormat: "d/M/y",
            enableTime: false,
            require: true,
            time_24hr: false,
            "plugins": [confirmDatePlugIn({
                confirmIcon: "<i class='fa fa-check'></i>",
                confirmText: "OK ",
                showAlways: true,
                theme: "dark"
            })]
        };
        flatpickr("#DatePurchased", dateConfig);
    }

    private SubmitWOMaterialForm() {
        BlockPageHelper.block();
        const form: HTMLFormElement | null = document.querySelector("#MaterialForm")
        if (form !== null) {
            if (!form?.checkValidity()) {
                form.classList.add('was-validated');
                BlockPageHelper.unblock();
                return false;
            }
        }

        const formData = $("#MaterialForm").serialize();
        var saveWo: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveWo[pair[0]] = decodeURIComponent(pair[1]);
        });
        if (saveWo.DatePurchased == "" || saveWo.SupplierId == '0') {
            form?.classList.add('was-validated');
            BlockPageHelper.unblock();
            if (saveWo.DatePurchased == "" && saveWo.SupplierId == '0')
                Swal.fire("Failed", "Supplier & Date Purchased is not Valid");
            else if (saveWo.DatePurchased == "")
                Swal.fire("Failed", "Date Purchased is not Valid Date");
            else
                Swal.fire("Failed", "Supplier is not a Valid");

            return false;
        }

        console.log(saveWo);
        const url = Genesis.url('/WorkOrder/SaveMaterial');
        $.post(url, { materialDTOVM: saveWo }, function (responseResult) {
            if (responseResult.status) {
                const redirectUrl = Genesis.url(responseResult.redirectUrl);
                window.location.href = redirectUrl;
            }
            else {
                BlockPageHelper.unblock();
            }
        });
    }
}